<template>
  <a
    href="#inquiry-form"
    class="m3-button m3-button--secondary"
    :class="additionalClassName"
    @click.prevent="handleClick"
  >
    {{ appealingText }}<i :class="atlasIconName"></i>
  </a>
</template>

<script setup>
import { useStore } from 'vuex';

const store = useStore();

const props = defineProps({
  appealingText: {
    type: String,
    required: true
  },
  pcrContent: {
    type: String,
    required: true
  },
  additionalClassName: {
    type: String,
    required: true
  },
  atlasIconName: {
    type: String,
    required: true
  }
});

const setPcrParams = params => {
  store.dispatch('requestParam/setPcrParams', params);
};
const handleClick = () => {
  setPcrParams({ key: 'pcr_content', value: props.pcrContent });
};
</script>
